import { render } from "./UserReport.vue?vue&type=template&id=1a558f4e&scoped=true&ts=true"
import script from "./UserReport.vue?vue&type=script&lang=ts"
export * from "./UserReport.vue?vue&type=script&lang=ts"

import "./UserReport.vue?vue&type=style&index=0&id=1a558f4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a558f4e"]])

export default __exports__